<template>
  <div>

    <div class="header">
      <a href="/beawanHome/home" class="header-logo">
        <div class="logo-line">
          <img class="logo-icon" src="../../static/img/beawan.svg">
          <img style="margin-left: 8px;" src="../../static/img/beawan_title.svg">
        </div>
        <div class="logo-line">
          <img src="../../static/img/beawan_text.svg">
          <img style="margin-left: 8px;" src="../../static/img/beawan_note.svg">
        </div>
      </a>

      <div class="header-tabs">
        <div class="header-tab-item">
          <a href="/beawanHome/" class="header-tab-item-text">独家</a>
          <div class="line"></div>
        </div>

        <div class="header-tab-item header-tab-selected" v-if="selected == 1">
          <div class="header-tab-item-text" style="cursor: default;">市场画像</div>
          <div class="line"></div>
        </div>
        <div class="header-tab-item" v-if="selected != 1">
          <div class="header-tab-item-text" @click="changeSelect(1)">市场画像</div>
          <div class="line"></div>
        </div>

        <div class="header-tab-item header-tab-selected" v-if="selected == 2">
          <div class="header-tab-item-text" @click="changeSelect(2)">公司研究</div>
          <div class="line"></div>
        </div>
        <div class="header-tab-item" v-if="selected != 2">
          <div class="header-tab-item-text" @click="changeSelect(2)">公司研究</div>
          <div class="line"></div>
        </div>

        <div class="header-tab-item header-tab-selected" v-if="selected == 4">
          <div class="header-tab-item-text" @click="changeSelect(4)">行业比较</div>
          <div class="line"></div>
        </div>
        <div class="header-tab-item" v-if="selected != 4">
          <div class="header-tab-item-text" @click="changeSelect(4)">行业比较</div>
          <div class="line"></div>
        </div>

        <div class="header-tab-item header-tab-selected" v-if="selected == 3">
          <div class="header-tab-item-text" style="cursor: default;">我的自选</div>
          <div class="line"></div>
        </div>
        <div class="header-tab-item" v-if="selected != 3">
          <div class="header-tab-item-text" @click="changeSelect(3)">我的自选</div>
          <div class="line"></div>
        </div>

      </div>

      <div class="header-user">
        <img class="bell-icon" src="../../static/img/bell.svg">

        <div v-if="!isLogin" class="user-login" @click="$router.push({ name: 'login' })">
          <!--        <a class="user-login" href="/beawanHome/" style="display: block;">-->
          <div style="width: 65px;height: 30px;line-height: 29px;text-align: center;
                      border: 1px solid;border-radius: 10px;">登录
          </div>
        </div>

        <div v-if="isLogin" class="user-logged">
          <div style="display: flex;align-items: center;">
            <div id="user-icon" style="width: 35px;height: 35px;">
              <img style="width: 35px;height: 35px;" src="../../static/img/user.svg">
            </div>
            <div id="user-name" style="margin-left: 5px;margin-right: 2px;color: #595959;">{{ userInfo.userNickName }}
            </div>
            <img src="../../static/img/down.svg">
          </div>
          <div class="user-button">
            <div class="user-button-item" @click="toUserInfo()" style="border-top: 1px solid #eee;">会员信息</div>
            <div class="user-button-item" @click="logout()">退出登录</div>
          </div>
        </div>

      </div>
    </div>

    <div style="background-color: #f3f3f3;min-height: calc(100vh - 77px);">
      <div style="width: 1200px;margin: 0 auto;padding: 20px 0;">
        <router-view />
      </div>
    </div>

    <div class="footer">
      <div>版权所有 © 杭州碧湾信息技术有限公司</div>
      <div style="margin-left: 20px;">
        <a style="color: #333;" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备2022014177号-1</a>
      </div>
    </div>

  </div>
</template>
  
<script>
import { linkName, sendRequestCompany } from '../../static/js/util';

export default {
  name: 'App',
  data() {
    return {
      token: '',
      isLogin: false,
      selected: 1,
      userInfo: {}
    }
  },
  watch: {
    //跳转页面后菜单也变化
    $route(to, from) {
      if (to.name == 'market') {
        this.selected = 1;
      } else if (to.name == 'companyResearch' || to.name == 'researchMain' || this.$route.name == 'business' || this.$route.name == 'companyReport') {
        this.selected = 2;
      } else if (to.name == 'optional') {
        this.selected = 3;
      } else if (to.name == 'induCompare') {
        this.selected = 4;
      }else if (to.name == 'header') {
        linkName(this, 'market');
      }else {
        this.selected = 0;
      }
    }
  },
  mounted() {
    this.token = localStorage.getItem('satoken');

    //刷新页面后恢复选中
    if (this.$route.name == 'market') {
      this.selected = 1;
    } else if (this.$route.name == 'companyResearch' || this.$route.name == 'researchMain' || this.$route.name == 'business') {
      this.selected = 2;
    } else if (this.$route.name == 'optional') {
      this.selected = 3;
    } else if (this.$route.name == 'header') {
      linkName(this, 'market');
    } else if (this.$route.name == 'induCompare') {
      this.selected = 4;
    } else {
      this.selected = 0;
    }

    this.loginState();
  },
  methods: {
    changeSelect(sign) {
      this.selected = sign;
      if (sign == 1) {
        linkName(this, 'market');
      } else if (sign == 2) {
        linkName(this, 'companyResearch');
      } else if (sign == 3) {
        linkName(this, 'optional');
      } else if (sign == 4) {
        linkName(this, 'induCompare');
      }
    },
    loginState() {
      sessionStorage.setItem('isLogin', false);
      var url = '/user/userInfo2';
      sendRequestCompany(url, 'get', {'device': 'web-pc'}, { 'satoken': this.token }, (res) => {
        if (res.code == 0) {
          this.isLogin = true;
          this.userInfo = res.data;
          sessionStorage.setItem('isLogin', true);
        }
      }, (err) => {
        console.log(err)
      });
    },
    logout() {

      sessionStorage.setItem('isLogin', false);
      localStorage.setItem('satoken', '');

      var url = '/user/logout';
      sendRequestCompany(url, 'get', null, { 'satoken': this.token }, (res) => {
        this.isLogin = false;
        window.location.href = '/beawanHome';
      }, (err) => {
        console.log(err)
      });
    },
    toUserInfo() {
      linkName(this, 'myUser');
    }
  }
}
</script>
  
<style scoped>
@import "../../static/css/mainIndex.css";

#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.footer {
  height: 20px;
  text-align: center;
  border-top: 1px solid #d1d1d1;
  font-size: 15px;
  padding: 3px 0;
  color: #333;
  display: flex;
  justify-content: center;
}
</style>
  